import { Flex, Text, mainTheme, Button } from 'dash-ui';

import { Amenity } from 'gql/generated.graphql';

import {
  ActionsWrapper,
  AmenityImage,
  AmenityItemWrapper,
  AmenityNameWrapper,
} from 'pages/amenities/AmenitiesPage/components/AmenitiesList/components/AmenityItem/AmenityItem.styles';

interface IProps {
  amenity: Amenity;
  onClickTrashIcon: () => void;
  onClickEditIcon: () => void;
}

function AmenityItem({ amenity, onClickTrashIcon, onClickEditIcon }: IProps) {
  return (
    <AmenityItemWrapper
      minWidth={230}
      h="fit-content"
      pb={2}
      pt={8}
      justifyContent="center"
      alignItems="center"
    >
      <Flex flexDirection="column" alignItems="center">
        <AmenityImage
          fit="scale-down"
          size={64}
          src={amenity.imageUrl || ''}
          alt={amenity.name}
        />
        <AmenityNameWrapper w={174}>
          <Text color={mainTheme.colors.n80}>{amenity.name}</Text>
        </AmenityNameWrapper>
      </Flex>
      <ActionsWrapper>
        <Button
          variation="primary"
          m={1}
          icon="edit"
          square
          onClick={onClickEditIcon}
        />
        <Button
          variation="primary"
          m={1}
          icon="trash"
          square
          onClick={onClickTrashIcon}
        />
      </ActionsWrapper>
    </AmenityItemWrapper>
  );
}

export default AmenityItem;
